export default __webpack_public_path__ + "static/media/marketing.0572ac12.svg";